import { useEffect } from "react";

/** Close dropdowns/menus when clicking or tapping anywhere outside the given ref. */
export default function useClickOutside(ref, onOutside, active = true) {
  useEffect(() => {
    if (!active) return;
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) onOutside();
    };
    document.addEventListener("pointerdown", handler);
    return () => document.removeEventListener("pointerdown", handler);
  }, [active]); // eslint-disable-line react-hooks/exhaustive-deps
}
